import React, { Component } from 'react';
import { connect } from 'react-redux';
import FontAwesome from 'react-fontawesome';
import { sprintf } from 'sprintf-js';
import actions from '../../redux/actions';
import Heading from '../Heading';

class PublicationComplete extends Component {
  handleClick = (e) => {
    this.props.resetAttribute();
    this.props.router.push('/');
  };

  componentDidMount() {
    window.onpopstate = this.onBackButtonEvent;
  }

  componentWillUnmount() {
    this.props.resetAttribute();
  }

  onBackButtonEvent = (e) => {
    e.preventDefault();
    this.props.resetAttribute();
    this.props.router.push('/copyright-reg');
  };

  render() {
    const { coreg } = this.props;
    const confirmNumber = coreg ? sprintf('%06d', coreg.id) : '';

    return (
      <div className="complete">
        <Heading text="You did it!" />
        <div className="content">
          <p>
            <FontAwesome name="check-circle" className="icon" />
          </p>
          <p>
            <b className="text-green">
              You have successfully setup automatic registration for your publication.
            </b>
          </p>
          <p>
            Cosynd will capture a snapshot of your homepage every day and complete your monthly registration with the U.S.
            Copyright Office for you. Please note that registration is not always guaranteed.
            The Copyright Office may deny your application if the information you have entered is false or does not meet their standards for registration.
            If there are any issues with your application, we'll work with you to resolve them. Otherwise, you can expect to receive your certificate in the mail each month.
          </p>
          <div className="tracking-number">
            <h4 className="text-primary">Tracking Number: {confirmNumber}</h4>
            <p>
              You can reference this tracking number if you need to communicate
              with us about your registration.
            </p>
          </div>
          <div>
            <button onClick={this.handleClick}>Done</button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  coreg: state.coreg.coreg,
});

const mapDispatchToProps = (dispatch) => ({
  resetAttribute: () => {
    dispatch(actions.resetCoregAttribute());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicationComplete);



// WEBPACK FOOTER //
// src/components/Publication/PublicationComplete.jsx